import axios from 'axios'

export default {
  updateProfile (payload) {
    return axios.patch('/api/settings/profile', payload)
  },

  // Global, app-wide flags (read on bootstrap; any authenticated user)
  getPublic () {
    return axios.get('/api/settings/public')
  },

  // Update global flags (admin only)
  updatePublic (payload) {
    return axios.patch('/api/admin/settings', payload)
  }
}
